import { useCallback, useReducer } from 'react';

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'SET_STATE': {
      return {
        ...state,
        ...payload,
      };
    }
    case 'SET_STATE_IF_NOT_LOADING': {
      if (state.isLoading) return;

      return {
        ...state,
        ...payload,
      };
    }
    default: {
      return state;
    }
  }
};

const useSelfExclusion = () => {
  const [state, dispatch] = useReducer(reducer, {});

  const setState = useCallback(payload => {
    dispatch({ type: 'SET_STATE', payload });
  }, []);

  const setStateIfNotLoading = useCallback(payload => {
    dispatch({ type: 'SET_STATE_IF_NOT_LOADING', payload });
  }, []);

  const onOpenSubmitPopup = useCallback(() => {
    setStateIfNotLoading({ isPopupOpen: true });
  }, [setState]);

  const onCloseSubmitPopup = useCallback(() => {
    setStateIfNotLoading({ isPopupOpen: false });
  }, [setStateIfNotLoading]);

  const setSelectedPeriod = useCallback(
    selectedPeriod => {
      setStateIfNotLoading({ selectedPeriod });
    },
    [setStateIfNotLoading],
  );

  return {
    ...state,
    setState,
    onOpenSubmitPopup,
    onCloseSubmitPopup,
    setSelectedPeriod,
  };
};

export default useSelfExclusion;
